module.exports = __webpack_public_path__ + "img/content.05cd13c.svg";